export const enum ProfileTabs {
    GeneralInfo = 'General Information',
    FinancialDetails = 'Financial Details',
    FeesMethods = 'Fees & Methods',
    TechnicalInformation = 'Technical Information '
};
